<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper form" v-if="pool!==null">
          <div class="moduleCard">
            <div class="row">
              <div class="field col-md-6 mb-5">
                <label class="text-dark">License Pool Name</label><br />
                <input class="mb-0" type="text" aria-label="Enter license pool name here" v-model.trim="pool.LicensePoolName">
              </div>
              <div class="field col-md-6 mb-5">
                <label class="text-dark">Where Do Users Login?</label><br />
                <b-form-select class="mb-0" type="text" aria-label="Enter where users will log in here" :options="portals" v-model="pool.PortalID"></b-form-select>

              </div>
            </div>
            <div class="row">
              <div class="field col-12 mb-5">
                <label class="text-dark">Description</label><br />
                <textarea v-model.trim="pool.PoolDescription"></textarea>
              </div>
            </div>

            <div class="row">
              <div class="field col-12 mb-5">
                <label class="text-dark">Terms and Conditions</label><br />
                <textarea v-model.trim="terms"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="field col-12 mb-5">
                <label class="text-dark">Pool Image</label><br />
                <div class="row">
                  <div class="col-12">
                    <img v-bind:src="pool.FullImage" width="50" height="50" onerror="this.src='/pool.svg'" />&nbsp;&nbsp;
                    <input type='file' id='fileinput' ref="tfiles" class='w25 ib mb-0' @change="getFile" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <button class="btn btn-primary btn-short fixmargin" @click="doSave">Save</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"

  export default {
    name: 'PoolEdit',
    components: {acheader,acfooter,poolsidebar},
    data() {
      return {
        fdata: null,
        pool: null,
        portals:[],
        terms: null
      }
    },
    methods: {
      doSave() {
  
        var fields = {
          LicensePoolID: this.pool.LicensePoolID,
          LicensePoolName: this.pool.LicensePoolName,
          Portal: this.pool.PortalID,
          PoolDescription: this.pool.PoolDescription
        };
     
        if (this.fdata!==null) {
          fields.PoolImage = this.fdata
          this.pool.FullImage=this.pool.FullImage+"&r="+Math.random(0,100000);
        }

        this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "Edit",
              Fields: fields
            },
            {
              Operation: "LicensePool",
              Function: "EditTerms",
              Fields: {
                LicensePoolID: this.pool.LicensePoolID,
                LicensePoolTerms: this.terms
              }
            }
          ]).then(r=> {      

            var cr = JSON.parse(r.CommandResult);
            if (cr.returnObjects[0].returnObject==="OK") {
              this.popDialog(0, "License pool data saved successfully");
              this.doPage().then(r=>{
                this.bootstrapPool(this.pool.LicensePoolID);
                this.$forceUpdate();
              })
            }
            else {
              this.popDialog(1, "License pool data did not save successfully");
            }
             
          });
      },
      getFile(event) {
      
        var r = new FileReader();
        var self=this;
        r.onload = function (e) {
          self.fdata = e.target.result;
        }
        r.readAsDataURL(this.$refs["tfiles"].files[0]);
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);
       
        this.apiCommand([
         {
           Operation: "LicensePool",
           Function: "GetTerms",
           Fields: {
             LicensePoolID: this.$route.params.id
           }        
         },
         {
           Operation: "Organization",
           Function: "GetPortals",
           Fields: {
             OrganizationID: this.sdata.activepool.OrganizationID
           }
         }]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            this.terms = cr.returnObjects[0].returnObject;

            this.portals.push({
              text: "Training Center",
              value: "b9360f8c-7f67-4e0a-a3e4-2730aace0412"
            });

            try {
              for(var portal of JSON.parse(cr.returnObjects[1].returnObject)) {
                if (portal.PortalID!=="b9360f8c-7f67-4e0a-a3e4-2730aace0412") {
                  this.portals.push({
                    text: portal.PortalName,
                    value: portal.PortalID
                  });
                }
              }
            }
            catch(e) {}
            
            this.pool=this.sdata.activepool;
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }
        });
       
      });
    }
  }
</script>
